import useDebounce from 'hooks/useDebounce';
import { default as React, default as React, useEffect, useState } from 'react';

export const CalendarToolbar = ({
  cellScale,
  setCellScale,
  filterString,
  setFilterString,
  debouncedFilterString,
}) => {
  return (
    <div
      className="mb-2 p-2 d-flex flex-row align-items-center justify-content-between rounded-2"
      style={{
        background: '#1e374f',
      }}
    >
      {/* Filter string input */}
      {setFilterString && (
        <div className="d-flex align-items-center gap-1">
          <input
            className="p-1 rounded-1"
            type="text"
            placeholder="Filter events..."
            value={filterString}
            onChange={(e) => setFilterString(e.target.value)}
            style={{
              background: '#0b1826',
            }}
          />
          {filterString && (
            <button
              type="button"
              onClick={() => setFilterString('')}
              className="border-none"
              style={{
                cursor: 'pointer',
              }}
              aria-label="Clear filter"
            >
              ×
            </button>
          )}
        </div>
      )}
      <div></div>
      <div className="flex flex-row align-items-center gap-2 mr-2 ">
        <label>Zoom </label>
        <input
          type="range"
          min={1}
          max={10}
          step={0.01}
          value={cellScale}
          onChange={(e) => setCellScale(Number(e.target.value))}
          style={{ cursor: 'pointer' }}
        />
        {(cellScale / 5).toFixed(2)}x
      </div>
    </div>
  );
};
